module.exports = __webpack_public_path__ + "media/six.0d2fb823.mp3";